import { Row, Col, BreakPoint } from '../../../components/atoms/Grid';
import Text from '../../../components/atoms/Text';
import Cartola from '../../../components/molecules/Cartola';
import Colors from 'components/tokens/Colors';
import { dateFormatter } from 'helpers/dateFormatter';
import styled, { css } from 'styled-components';
import { colaboratorsFormatter } from 'helpers/colaboratorNameFormatter';
import { render } from 'storyblok-rich-text-react-renderer';
import { getAssetURL } from 'helpers/getAssetURL';
import { getHat } from 'helpers/getHat';
import getNewsUrl from 'helpers/getNewsUrl';
import { useEditor } from 'providers/generalContext';
import RouterLink from 'components/atoms/RouterLink';
import { useParams } from 'react-router-dom';
import placeholder from 'assets/image_placeholder.png';

const hats = [
    'verificação',
    'checagem',
    'reportagem',
    'notícia',
    'artigos',
    'explicador',
    'opinião',
    'educação',
    'na mochila',
    'abre aspas',
    'achado',
    'institucional',
    'podcast',
    'acontecendo na lupa'
];

const NewsCard = ({ data, hasTags }) => {
    const findTag = item => {
        const counter = {
            true: {
                text: 'Verdadeiro',
                value: 0
            },
            false: {
                text: 'Falso',
                value: 0
            },
            exaggerated: {
                text: 'Exagerado',
                value: 0
            },
            true_but: {
                text: 'Verdadeiro, mas...',
                value: 0
            },
            early: {
                text: 'Ainda é cedo',
                value: 0
            },
            contradictory: {
                text: 'Contraditório',
                value: 0
            },
            unsustainable: {
                text: 'Insustentável',
                value: 0
            },
            watchful: {
                text: 'De olho',
                value: 0
            },
            underrated: {
                text: 'Subestimado',
                value: 0
            }
        };

        item?.content?.body?.content?.map(blok => {
            if (blok.attrs?.body?.length > 0 && blok.attrs?.body[0]?.component === 'classification') {
                const validation = blok?.attrs?.body[0]?.validation;
                switch (validation) {
                    case 'false':
                        return (counter.false.value += 1);
                    case 'true':
                        return (counter.true.value += 1);
                    case 'exaggerated':
                        return (counter.exaggerated.value += 1);
                    case 'true_but':
                        return (counter.true_but.value += 1);
                    case 'early':
                        return (counter.early.value += 1);
                    case 'contradictory':
                        return (counter.contradictory.value += 1);
                    case 'unsustainable':
                        return (counter.unsustainable.value += 1);
                    case 'watchful':
                        return (counter.watchful.value += 1);
                    case 'underrated':
                        return (counter.underrated.value += 1);
                    default:
                        return null;
                }
            }
            return null;
        });

        return (
            <>
                <Row>
                    <Col>
                        <Text size="12 16" color={Colors.grey} highlight>
                            {counter.true.value > 0 && `${counter.true.text} (${counter.true.value})`}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text size="12 16" color={Colors.grey} highlight>
                            {counter.false.value > 0 && `${counter.false.text} (${counter.false.value})`}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text size="12 16" color={Colors.grey} highlight>
                            {counter.exaggerated.value > 0 &&
                                `${counter.exaggerated.text} (${counter.exaggerated.value})`}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text size="12 16" color={Colors.grey} highlight>
                            {counter.true_but.value > 0 && `${counter.true_but.text} (${counter.true_but.value})`}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text size="12 16" color={Colors.grey} highlight>
                            {counter.early.value > 0 && `${counter.early.text} (${counter.early.value})`}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text size="12 16" color={Colors.grey} highlight>
                            {counter.contradictory.value > 0 &&
                                `${counter.contradictory.text} (${counter.contradictory.value})`}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text size="12 16" color={Colors.grey} highlight>
                            {counter.unsustainable.value > 0 &&
                                `${counter.unsustainable.text} (${counter.unsustainable.value})`}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text size="12 16" color={Colors.grey} highlight>
                            {counter.watchful.value > 0 && `${counter.watchful.text} (${counter.watchful.value})`}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text size="12 16" color={Colors.grey} highlight>
                            {counter.underrated.value > 0 && `${counter.underrated.text} (${counter.underrated.value})`}
                        </Text>
                    </Col>
                </Row>
            </>
        );
    };

    useEditor();

    const { slug } = useParams();

    const hideHat = hats.includes(slug?.replace(/[-]+/g, ' ').toLowerCase()) ? true : false;

    return (
        <Row alignItems="center">
            <Col size="12">
                {data &&
                    data.map((item, key) => {
                        const imageUrl =
                            item?.content?.featured_image?.filename || item?.content?.cover_image?.filename;

                        return (
                            <Row mb="5" key={key}>
                                <Col size="6 9">
                                    <Row>
                                        <Col size="12 3" order="3 0">
                                            <Row mb="2.5">
                                                <Col>
                                                    <Text size="12 16" color={Colors.grey}>
                                                      {
                                                        item?.content.schedule ?
                                                        dateFormatter(item.content.schedule.replace(" ", "T") + ":00Z") :
                                                        item?.first_published_at ?
                                                        dateFormatter(item.first_published_at) :
                                                        ''
                                                      }
                                                    </Text>
                                                </Col>
                                            </Row>
                                            {hasTags && findTag(item)}
                                        </Col>

                                        <Col size="12 9" mb="1 0">
                                            <Row>
                                                {hideHat ? (
                                                    ''
                                                ) : (
                                                    <Col size="12" mb="1">
                                                        <Cartola
                                                            value={getHat(
                                                                item?.content?.hat,
                                                                item?.content?.custom_hat
                                                            )}
                                                        />
                                                    </Col>
                                                )}
                                                <RouterLink
                                                    key={`${item?.name} - ${item?.uuid}`}
                                                    to={getNewsUrl(item?.full_slug, item?.first_published_at)}
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Col size="12" mb="0 1">
                                                        <Text highlight size="12 24" lineHeight="16 21" hover>
                                                            {item?.name}
                                                        </Text>
                                                    </Col>
                                                    <Col size="hidden 12" mb="1">
                                                        <StyledText body2>
                                                            {item?.content?.resume
                                                                ? render(item?.content?.resume)
                                                                : `Resumo da matéria`}
                                                        </StyledText>
                                                    </Col>
                                                    <Col size="hidden 12">
                                                        <Text body2 color={Colors.grey}>
                                                            {item?.__typename === 'ArticleItem'
                                                                ? null
                                                                : colaboratorsFormatter(item?.content?.authors, true)}
                                                        </Text>
                                                    </Col>
                                                </RouterLink>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col size="6 3">
                                    <PictureBox>
                                        <SmallImg bg={getAssetURL(imageUrl) || placeholder} />
                                    </PictureBox>
                                </Col>
                            </Row>
                        );
                    })}
            </Col>
        </Row>
    );
};

const StyledText = styled(Text)`
    a {
        color: black;
        text-decoration: none;
    }

    a:hover {
        color: black;
        text-decoration: none;
    }
`;

const PictureBox = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;

    &:hover {
        > div {
            transform: scale(1.04);
            transition: transform 300ms ease;
        }
    }
`;

const SmallImg = styled.div`
    width: 148px;
    height: 148px;

    background-image: url(${({ bg }) => bg});
    background-size: cover;
    background-position: center;
    background-color: #383838;

    ${BreakPoint(
        'sm',
        css`
            width: 264px;
            height: 184px;
        `
    )}
`;

export default NewsCard;
